// Arquivo de configuração centralizado
//export const BASE_URL = "https://pmprod.fly.dev";
export const BASE_URL = "http://api.podemarcar.com.br";

// O caminho completo para a API (com o prefixo /api)
export const API_BASE_URL = `${BASE_URL}/api`;
